<template
  bindable="size,cols"
  class="col-${size ? size : 'md'}-${cols ? cols : '8'}"
>
  <au-slot></au-slot>
</template>
